<template>
    <div id="head">
        <a href="mailto:dm.cauwels@verizon.net">
            <svg viewBox="0 0 45.54 45.54">
                <title>Email</title>
                <circle id="PermanentEmailRing" cx="22.77" cy="22.77" r="22"/>
                <circle id="EmailRing" cx="22.77" cy="22.77" r="22"/>
                <path id="EmailLogo" d="M16.1,21.9l2.5,1.6c1.4.9,2.5,1.6,3.2,2.1a2.19,2.19,0,0,0,.5.3,5.74,5.74,0,0,0,.7.4,2.09,2.09,0,0,1,.6.4c.2.1.5.2.7.3a1.27,1.27,0,0,0,.6.1h0a1.27,1.27,0,0,0,.6-.1c.2-.1.5-.2.7-.3a3.11,3.11,0,0,0,.6-.4,4.35,4.35,0,0,1,.7-.4c.3-.2.4-.3.5-.3.8-.5,2.7-1.7,5.7-3.7a6.73,6.73,0,0,0,1.5-1.4,2.72,2.72,0,0,0,.6-1.7,1.76,1.76,0,0,0-.6-1.3A1.35,1.35,0,0,0,34,17H16a2,2,0,0,0-1.5.6,2.32,2.32,0,0,0,.2,3.1A5.26,5.26,0,0,0,16.1,21.9Zm18.7,1.2c-2.7,1.7-4.7,3-6.1,3.9a9,9,0,0,1-1.1.7,3.34,3.34,0,0,1-1.2.5,3.53,3.53,0,0,1-1.4.3h0a3.93,3.93,0,0,1-1.4-.3c-.5-.2-.9-.4-1.2-.5s-.7-.4-1.1-.7c-1.1-.7-3.1-2.1-6.1-3.9a4,4,0,0,1-1.2-1v9a1.76,1.76,0,0,0,.6,1.3A1.82,1.82,0,0,0,16,33H34a2.39,2.39,0,0,0,1.4-.5,1.76,1.76,0,0,0,.6-1.3v-9A9.38,9.38,0,0,1,34.8,23.1Z" transform="translate(-2.23 -2.23)"/>
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        link: String,
        darkMode: Boolean
    },
}
</script>

<style scoped>
a > svg > #EmailRing {
    fill: #e2a246;
    opacity: 0;
    transition: opacity .3s linear;
}
svg:hover > #EmailRing {
    opacity: 1;
}
#PermanentEmailRing {
    stroke: #FFF;
    stroke-width: 1px;
    fill: none;
}
#EmailLogo {
    fill-rule: evenodd;
    fill: #FFF
}
#head {
    height: 45px;
    width: 45px;
    margin-right: 5px;
    margin-left: 10px;
    /* margin-bottom: 10px; */
}
svg {
    width: 45px;
}
</style>